var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
/**
 * QAEventInfo defines QA market/event.
 *
 * @typedef QAEventInfo
 * @type {Object}
 * @property {id} Unique identifier
 * @property {name} Name of the event
 * @property {typeId} type of the event (RaceCard,TrapMarket etc.)
 * @property {date} Date of event
 * @property {lines} Hashtable of QALines
 * @property {branchId} brachId for the event
 * @property {leagueId} Id of the league
 * @property {leagueName} Name of the league
 * @property {link} used for SEO navigation
 */
var QAEventInfo = /** @class */ (function () {
    function QAEventInfo(source) {
        this.id = source.id;
        this.typeId = source.typeId;
        this.branchId = source.branchId;
        this.leagueName = source.leagueName;
        this.leagueId = source.leagueId;
        this.lines = source.lines;
        this.date = source.date;
        this.typeName = source.typeName;
        this.name = source.name;
        this.link = source.link;
        this.isDanger = source.isDanger;
    }
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], QAEventInfo.prototype, "lines", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], QAEventInfo.prototype, "isDanger", void 0);
    return QAEventInfo;
}());
export { QAEventInfo };
//# sourceMappingURL=QAEventInfo.js.map